<template>
  <Cfg>
    <slot>
      <div class="animated fadeIn">
        <Alerts ref="alert"/>
        <Forms ref="frmGroup"
          :title="this.$lang.Holidays.TitleForm"
          :showHelp="true"
          :showClearButton="true"
          :showSaveButton="true"
          v-on:Clear="onClear"
          v-on:Save="onSave">
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtHolidaysName"><small class="text-danger">*</small> {{$lang.Holidays.LabelName}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              name="txtHolidaysName"
                              :placeholder="$lang.Holidays.PlaceholderEnterName"
                              v-model="form.name.value"
                              :size="form.name.maxlength"
                              :required="form.name.required"
                              :state="form.name.state"></b-form-input>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-6">
              <label><small class="text-danger">*</small> {{ $lang.Holidays.LabelType }}:</label>
              <div class="input-group">
                <b-form-select v-model="form.type.value"
                  :options="[{ value: '1', text: $lang.Holidays.OptionFixed },{ value: '2', text: $lang.Holidays.OptionRotary }]" class="mb-3" >
                   <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-6">
              <label for="txtDate"><small class="text-danger">*</small> {{$lang.Holidays.LabelData}}:</label>
              <div class="input-group">
                <datepicker name="datetimeHoliday" v-model="form.date.value"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fa fa-close'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"/>

              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtDescription"> {{$lang.Holidays.LabelDescription}}:</label>
              <b-form-textarea id="txtDescription"
                          name="txtDescription"
                          v-model.trim="form.description.value"
                          :placeholder="$lang.Holidays.PlaceholderEnterDescription"
                          :rows="form.description.rows"
                          :size="form.description.maxlength"
                          :noResize="form.description.noResize"></b-form-textarea>
              <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
            </div>
          </div>
        </Forms>

        <Tables ref="tableGrid"
            :columns="[$lang.Holidays.DataTable.Name,
                       $lang.Holidays.DataTable.Date,
                       $lang.Common.DataTable.Status,
                       $lang.Common.DataTable.ActionDate,
                       $lang.Common.DataTable.AccountAction,
                       $lang.Common.DataTable.Actions]"
            :showSearch="true"
            :showPrint="true"
            :showDownload="true"
            :showFullscreen="true"
            v-on:Load="onLoad">
          <tr v-for="obj in this.objList" v-bind:key="obj.id">
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name" classCss="text-left" />
            <TableColumn :IsDateOnly="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.date" />
            <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
            <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.accountUserNameUpdate" />
            <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
          </tr>
        </Tables>
      </div>
    </slot>
  </Cfg>
</template>
<script>
import Holiday from './holiday.js'

export default Holiday
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/holiday/holiday.vue